import { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';

const formatTextWithSymbols = (text) => {
  if (!text) return '';
  
  // Process special arrow characters and properly format them
  return text.split(/\n/).map((line, i) => {
    // Format the right arrow symbol
    if (line.trim().startsWith('→')) {
      return (
        <Box key={i} sx={{ marginTop: '0.5em', marginBottom: '0.2em' }}>
          <span className="arrow-right">→</span>
          <span>{line.substring(1)}</span>
        </Box>
      );
    }
    // Format the return arrow (indented)
    else if (line.trim().startsWith('↳')) {
      return (
        <Box key={i} sx={{ marginTop: '0.2em', marginBottom: '0.5em', paddingLeft: '1.2em' }}>
          <span className="arrow-return">↳</span>
          <span>{line.substring(1)}</span>
        </Box>
      );
    }
    // Handle empty lines with proper spacing
    else if (line.trim() === '') {
      return <Box key={i} sx={{ height: '1em' }} />
    }
    // Regular text
    else {
      return <Box key={i} sx={{ marginBottom: '0.5em' }}>{line}</Box>;
    }
  });
};

const TypeWriter = ({ text, speed = 10 }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    // Reset when new text is received
    setDisplayedText('');
    setCurrentIndex(0);
    setIsComplete(false);
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    } else {
      setIsComplete(true);
    }
  }, [currentIndex, text, speed]);

  return (
    <Typography 
      variant="body1" 
      component="div"
      sx={{ 
        fontFamily: 'inherit',
        lineHeight: 1.8,
        minHeight: '300px'
      }}
    >
      {isComplete ? (
        formatTextWithSymbols(displayedText)
      ) : (
        // Show plain text during typing animation
        <Box sx={{ whiteSpace: 'pre-wrap' }}>
          {displayedText}
          <span className="cursor" style={{ 
            borderRight: '2px solid #0A66C2',
            animation: 'blink 1s step-end infinite'
          }} />
        </Box>
      )}
    </Typography>
  );
};

export default TypeWriter; 